export default function FieldCopyContent_ActionClick(label: string, value:string) {
    gd.utils.copyToClipboard(value)
    gd.growl.success("{0} copied to clipboard".f(label))
}